import React, { CSSProperties, FC, PropsWithChildren } from 'react'
import classNames from 'classnames'
import { JSX } from '@ionic/core'
import { IonFooter } from '@ionic/react'

import Header, { Props as HeaderProps } from './header'
import Content from './content'

interface ContentProps extends JSX.IonContent {
	className?: string
	style?: CSSProperties & Record<string, string>
}

interface FooterProps extends JSX.IonFooter {
	className?: string
	style?: CSSProperties
}

interface Props {
	/**
	 * The page name, used for Cypress testing.
	 */
	dataCy: `page-${string}`
	headerProps?: HeaderProps
	contentProps?: ContentProps
	footer?: {
		component: React.ReactNode
		props?: FooterProps
	}
	dataItemId?: string
	dataItemType?: string
	dataItemSubtype?: string
}

const Page: FC<PropsWithChildren<Props>> = ({
	dataCy,
	headerProps,
	contentProps,
	footer,
	children,
	dataItemId,
	dataItemType,
	dataItemSubtype,
}) => {
	const { component: footerComponent, props: footerProps } = footer || {}

	return (
		<Content
			{...contentProps}
			className={classNames('page-content', contentProps?.className)}
			data-item-id={dataItemId}
			data-item-type={dataItemType}
			data-item-subtype={dataItemSubtype}
			data-cy={dataCy}
		>
			{headerProps && <Header {...headerProps} className={classNames('page-header', headerProps?.className)} />}
			<div>{children}</div>
			{footerComponent && (
				<IonFooter {...footerProps} className={classNames('ion-no-border', footerProps?.className)}>
					{footerComponent}
				</IonFooter>
			)}
		</Content>
	)
}

export default Page
